import { BLUE } from './constants';

export const fieldStyle = {
  width: '100%',
  border: '1px solid #c8d4e4',
  borderRadius: 7,
  padding: '10px 12px',
  color: '#23344d',
  background: '#fff',
  font: 'inherit',
  boxSizing: 'border-box',
};
export const labelStyle = {
  display: 'block',
  color: '#43546c',
  fontSize: 12,
  fontWeight: 700,
  lineHeight: 1.8,
};
export const workflowStyle = {
  marginTop: 12,
  padding: 13,
  border: '1px solid #ccd8e6',
  borderRadius: 8,
  background: '#f7f9fc',
  color: '#33445d',
};
export const alertStyle = {
  background: '#fff3f0',
  border: '1px solid #e8b4a8',
  color: '#8a372b',
  borderRadius: 7,
  padding: '10px 12px',
  fontSize: 12,
  marginTop: 12,
};
export const buttonStyle = (variant = 'quiet') => {
  const common = {
    borderRadius: 7,
    padding: '8px 12px',
    fontWeight: 700,
    fontSize: 12,
    cursor: 'pointer',
  };
  if (variant === 'primary')
    return { ...common, border: `1px solid ${BLUE}`, color: '#fff', background: BLUE };
  if (variant === 'danger')
    return { ...common, border: '1px solid #c04b4b', color: '#a43a3a', background: '#fff8f7' };
  return { ...common, border: '1px solid #c8d4e4', color: '#33445d', background: '#fff' };
};
